var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523.8,
    height: 523.8,
    viewBox: "0 0 523.79999 523.79999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#d);}\n\t.st1{fill:#E5E5E4;}\n\t.st2{clip-path:url(#c);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{clip-path:url(#b);}\n\t.st5{fill:#4A8CFF;}\n\t.st6{clip-path:url(#a);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.8 231.8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "h",
    cx: -395.9,
    cy: 30.1,
    r: 261.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-670.7-244.7h549.5v549.5h-549.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.8 231.8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: -395.9,
    cy: 30.1,
    r: 256.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m-665.5-239.5h539.3v539.3h-539.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.8 231.8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: -395.9,
    cy: 30.1,
    r: 236.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m-645-219h498.2v498.2h-498.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.8 231.8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m-324-0.6 66.8-48.8c5.8-4.8 10.3-3.6 10.3 5.1v148.8c0 9.9-5.5 8.7-10.3 5.1l-66.8-48.7zm-226-43.3v111c0.1 25.1 20.6 45.3 45.6 45.2h161.8c4.6 0 8.3-3.7 8.3-8.2v-111c-0.1-25.1-20.6-45.3-45.6-45.2h-161.8c-4.6 0-8.3 3.7-8.3 8.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m-562.8-64.9h328.7v190h-328.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.442883b08aaeb6f47dcce9bbac004ace.svg";
export { ForwardRef as ReactComponent };